import {
  ModalActionContainer,
  ModalSectionButton,
  ModalText,
} from "../../common/components/modules/modal/modalComponents";
import React from "react";
import {Pencil} from "styled-icons/heroicons-outline/Pencil";
import styled from "styled-components";
import useRouter from "../../common/hooks/useRouter";

function AddressSection({placeholder, address, editRoute}) {
  const router = useRouter();
  const _address = address ? address.toString() : "Set delivery address...";

  return (
    <>
      <ModalSectionButton onClick={() => router.push(editRoute)}>
        <ModalText>{_address}</ModalText>
        <ModalActionContainer>
          <PencilIcon />
        </ModalActionContainer>
      </ModalSectionButton>
    </>
  );
}

const PencilIcon = styled(Pencil)`
  height: 20px;
  width: 20px;
  color: black;
`;

export default AddressSection;
